<template>
  <div class="sky-business-survey">
    <div class="business-survey-group">
      <div class="business-survey-group-title">
        <div class="business-survey-group-title-icon"></div>
        <div class="business-survey-group-title-value">场景选择</div>
        <el-tooltip class="item" effect="dark" :content="sceneDesc" :disabled="!sceneDesc" placement="bottom">
          <div class="wsp-word-break" slot="content">{{ sceneDesc }}</div>
          <div class="business-survey-group-title-tip wsp-width-60 wsp-overflow-hidden">
            <span class="bg-red">{{ sceneDesc }}</span>
          </div>
        </el-tooltip>
      </div>
      <div class="business-survey-group-content">
        <div class="business-info-item scene-group">
          <div class="scene-group-item" v-for="(sceneGroup, key) in specSceneItemGroup" :key="key">
            <div class="scene-group-item-title">{{ key }}：</div>
            <div class="scene-group-item-content">
              <div class="wsp-display-flex scene-group-header" v-if="key === '业务场景'">
                <div
                  v-for="scene_index in specSceneItemGroup_index[key]"
                  :key="scene_index"
                  :class="
                    `wsp-padding-lr-3 scene-group-header-item ${
                      scene_index_name === scene_index ? 'scene-group-header-item-border' : ''
                    }`
                  "
                  @click="scene_index_name = scene_index"
                >
                  {{ scene_index }}
                </div>
              </div>
              <div class="scene-group-item-value">
                <div
                  v-for="(sceneItem, index) in sceneGroup"
                  :key="index"
                  :class="
                    `${
                      scene_index_name !== '所有场景' && key === '业务场景'
                        ? sceneItem.sceneDirName === scene_index_name
                          ? 'scene-item-checkbox'
                          : 'scene-item-hidder'
                        : 'scene-item-checkbox'
                    }`
                  "
                >
                  <el-checkbox
                    v-if="sceneItem.sceneType !== 'LIMIT_SCENE'"
                    v-model="specSceneMap[sceneItem.id].select"
                    @change="selectSpecScene(sceneItem.select, sceneItem, index, key)"
                  >
                    <div class="wsp-display-flex" style="cursor: pointer;">
                      {{ sceneItem.sceneName }}
                    </div>
                  </el-checkbox>
                  <div v-else class="sk-link--normal wsp-link" @click="showSceneCasePage(sceneItem)">
                    <el-checkbox disabled>
                      <div class="wsp-display-flex" style="cursor: pointer;">
                        {{ sceneItem.sceneName }}
                      </div>
                    </el-checkbox>
                  </div>
                  <!-- </el-tooltip>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business-survey-group">
      <div class="business-survey-group-title">
        <div class="business-survey-group-title-icon"></div>
        <div class="business-survey-group-title-value">
          产品版本选择
        </div>
        <!-- <div class="business-survey-group-title-tip wsp-handel-point " @click="handelSelectProductVersion">
          <el-button type="primary" size="small">选择产品及对应版本</el-button>
        </div> -->
      </div>
      <div>
        <div class="business-info-item  wsp-margin-6 wsp-display-flex">
          <div
            v-for="(value, index) in productVersion"
            :key="index"
            v-show="selectProductVersion.length > 0"
            class="wsp-border wsp-text-align-center wsp-width-20 wsp-border-radius-6 wsp-margin-6"
          >
            <div class="">
              <div class="wsp-border-bottom wsp-line-height-28">
                <strong>{{ value.serial }}</strong>
              </div>
              <div class="wsp-line-height-48">{{ value.productVersion }}</div>
            </div>
          </div>
          <div
            :style="{ borderColor: currentColor }"
            class="wsp-border wsp-text-align-center wsp-width-20 wsp-border-radius-6 wsp-border-transition wsp-margin-6 wsp-border-shadom"
            @click="handelSelectProductVersion"
            v-if="selectProductVersion.length === 0"
          >
            <div style="height: 76px;cursor: pointer;">
              <el-button type="text" size="small" class="el-icon-search">选择产品及对应版本</el-button>
              <div class="bg-red" v-if="showText">
                <i class="el-icon-warning"></i>
                <span>
                  请点击进行对应的产品以及版本信息选择
                </span>
              </div>
            </div>
          </div>

          <!-- <div
            class="wsp-border wsp-text-align-center wsp-width-20 wsp-border-radius-6 wsp-margin-6 wsp-border-border-red backgroud-color-e2e7f3 "
            @click="handelSelectProductVersion"
            v-if="selectProductVersion.length === 0"
          >
            <div style="line-height: 76px;">
              <el-button type="text" size="small" class="el-icon-search">选择产品及对应版本</el-button>
            </div>
          </div> -->
          <div
            class="wsp-border wsp-text-align-center wsp-width-20 wsp-border-radius-6 wsp-margin-6 wsp-border-shadom"
            @click="handelSelectProductVersion"
            v-if="selectProductVersion.length > 0"
          >
            <div style="height: 76px;cursor: pointer;">
              <el-button type="text" size="small" class="el-icon-edit">修改产品对应的版本</el-button>
              <div class="color-38a4f5">
                <i class="el-icon-warning"></i>
                <span>
                  点击可进行修改对应的产品以及版本信息
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else class="wsp-text-align-center font-size-16  color-E69D01">
          <div v-if="hasChangScene">
            场景已经变更，请重新点击上方的【选择产品及对应版本】选择产品版本
          </div>
          <div v-else>
            请点击选择上方的【选择产品及对应版本】
          </div>
        </div> -->
      </div>
    </div>
    <div class="business-survey-group">
      <div class="business-survey-group-title">
        <div class="business-survey-group-title-icon"></div>
        <div class="business-survey-group-title-value">场景功能选择</div>
        <div class="business-survey-group-title-tip color-ccc"></div>
      </div>
      <div ref="contentSceneDetail" class="content-scene-detail">
        <div class="scene-simple-card">
          <el-card
            :class="`scene-item ${selectFunctionItem && slectItem.id === selectFunctionItem.id ? 'active' : ''}`"
            v-for="(slectItem, key) in selectScene"
            :key="key"
            shadow="always"
          >
            <div slot="header" class="clearfix">
              <el-tooltip
                class="item"
                effect="dark"
                v-if="isShowTooltip(slectItem.sceneName)"
                :content="slectItem.sceneName"
                placement="top-start"
              >
                <div @click="selectSceneFunction(slectItem, key)" class="scene-item-title">
                  <div
                    v-if="slectItem.instructions && slectItem.sceneType === 'BUSI_SCENE'"
                    class="wsp-padding-lr-3 font-size-12 backgroud-color-E69D01 wsp-border-radius wsp-margin-right-3 color-fff"
                  >
                    风险
                  </div>
                  {{ slectItem.sceneName }}
                </div>
              </el-tooltip>
              <div v-else @click="selectSceneFunction(slectItem, key)" class="scene-item-title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  v-if="slectItem.instructions"
                  :content="slectItem.instructions"
                  placement="top-start"
                >
                  <div
                    v-if="slectItem.instructions && slectItem.sceneType === 'BUSI_SCENE'"
                    class="wsp-padding-lr-3 font-size-12 backgroud-color-E69D01 wsp-border-radius wsp-margin-right-3 color-fff"
                  >
                    风险
                  </div>
                </el-tooltip>
                {{ slectItem.sceneName }}
              </div>
              <el-button style="float: right; padding: 15px 6px" type="text" @click="showSceneCasePage(slectItem)"
                >场景说明</el-button
              >
            </div>
            <div class="scene-item-content wsp-display-flex" @click="selectSceneFunction(slectItem, key)">
              <div class="wsp-text-align-center scene-attr-item">
                <span class="wsp-padding-lr-3 font-size-18 bg-3bb113">{{ slectItem.selectFeatrueCont }}</span>
                <span class="wsp-padding-lr-3 font-size-18">/</span
                ><span class="wsp-padding-lr-3 font-size-18 bg-red">{{ slectItem.featureTotal }}</span>
              </div>
            </div>
            <div class="wsp-display-flex font-size-10" @click="selectSceneFunction(slectItem, key)">
              <div class="wsp-width-33 wsp-text-align-center wsp-border-right">
                <span class="wsp-padding-lr-3 ">推荐</span
                ><span class="wsp-padding-lr-3 bg-3bb113">{{ slectItem.selectRecommentCont }}</span
                >/<span class="wsp-padding-lr-3 bg-red">{{ slectItem.recommentCont }}</span>
              </div>
              <div class="wsp-width-33 wsp-text-align-center wsp-border-right">
                <span class="wsp-padding-lr-3">必选:</span
                ><span class="wsp-padding-lr-3 bg-3bb113">{{ slectItem.selectRequiredCont }}</span
                >/<span class="wsp-padding-lr-3 bg-red">{{ slectItem.requiredCont }}</span>
              </div>
              <div class="wsp-width-33 wsp-text-align-center">
                <span class="wsp-padding-lr-3">可选</span
                ><span class="wsp-padding-lr-3 bg-3bb113">{{ slectItem.selectOptionalCont }}</span
                >/<span class="wsp-padding-lr-3 bg-red">{{ slectItem.optionalCont }}</span>
              </div>
            </div>
          </el-card>
        </div>
        <div v-if="selectProductVersion.length > 0">
          <div v-for="(slectItem, key) in selectScene" :key="key">
            <div
              class="scene-item-function"
              v-show="slectItem.id === selectFunctionItem.id && slectItem.featureCount !== 0"
            >
              <function-table
                :ref="slectItem.id"
                :params="slectItem"
                :productVesionId="selectProductVersion"
                :projectCompetitors="projectCompetitors"
                :productSelectFeatureIds="productVersionSelectFeature"
                @changeSelect="functionChangeSelect"
                @reqEnd="queryEnd"
              ></function-table>
            </div>
            <div
              class="scene-item-function-empty wsp-text-div-center"
              v-show="slectItem.id === selectFunctionItem.id && selectFunctionItem.featureCount === 0"
            >
              <div class="font-size-16  color-E69D01">
                本场景的推荐功能需要结合实际需求选择，请到“场景价值功能”场景中选择，如需测试通用功能，请到“基础功能”场景中选择
              </div>
            </div>
          </div>
        </div>
        <div v-else class="wsp-text-align-center font-size-16  color-E69D01">
          场景功能的选择需要先选择产品版本
        </div>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :visible="caseDialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
      class="content-scene-drawer-detail"
    >
      <div class="scene-case-detail-content">
        <div class="business-survey-group" style="margin-top: -70px;margin-bottom: 50px;">
          <div class="business-survey-group-title">
            <div class="business-survey-group-title-icon"></div>
            <div class="business-survey-group-title-value">{{ $t('pocMng.case') }}</div>
          </div>
        </div>
        <div class="scene-case-detail-item">
          <div class="item-label">场景：</div>
          <div class="item-value">{{ caseDetail.sceneName }}</div>
        </div>
        <div class="scene-case-detail-item">
          <div class="item-label">场景特征：</div>
          <div class="item-value">{{ caseDetail.sceneDesc }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="!isChannel">
          <div class="item-label">
            <div style="float: right;">
              注意事项：
            </div>
            <div
              style="float: right;"
              v-if="caseDetail.instructions && caseDetail.sceneType === 'BUSI_SCENE'"
              class="wsp-padding-lr-3 font-size-12 backgroud-color-E69D01 wsp-border-radius wsp-margin-right-3 color-fff"
            >
              风险
            </div>
          </div>
          <div class="item-value">{{ caseDetail.instructions }}</div>
        </div>
        <div class="scene-case-detail-item">
          <div class="item-label">
            应对策略：
          </div>
          <div class="item-value">{{ caseDetail.solutionCase }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="caseDetail.sceneType !== 'LIMIT_SCENE'">
          <div class="item-label">终端模式：</div>
          <!-- <div class="item-value">
            <el-tag class="item-tag" v-for="(item, index) in caseDetail.desktopArchToList" :key="index" type="normal">{{
              item
            }}</el-tag>
          </div> -->
          <div class="item-value">{{ caseDetail.desktopArch }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="caseDetail.sceneType !== 'LIMIT_SCENE'">
          <div class="item-label">桌面模式：</div>
          <div class="item-value">{{ caseDetail.desktopType }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="caseDetail.sceneType !== 'LIMIT_SCENE'">
          <div class="item-label">推荐服务器型号：</div>
          <div class="item-value">{{ caseDetail.recommendServer }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="caseDetail.sceneType !== 'LIMIT_SCENE'">
          <div class="item-label">推荐终端型号：</div>
          <div class="item-value">{{ caseDetail.recommendTerminalName }}</div>
        </div>
        <div class="scene-case-detail-item" v-if="caseDetail.sceneType !== 'LIMIT_SCENE'">
          <div class="item-label">版本支持：</div>
          <div class="item-value">{{ caseDetail.productName }}</div>
        </div>
        <div class="scene-case-detail-item">
          <div class="item-label">客户问题：</div>
          <div class="item-value">{{ caseDetail.customerProblem }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { RadioGroup, RadioButton, CheckboxGroup, Checkbox, Drawer, Button, Tag, Card, Tooltip } from 'element-ui'

import functionTable from './functionTable'

import ProductVersionSelect from '../../common/ProductVersionSelect'

import { getIndustryScene, saveSceneResearch, getSceneResearch, listSpecFeature } from '@/api/businessResearch'
import { getProjectCompetitor } from '@/api/project'
import { getSceneDetail } from '@/api/scene'

import { isDeepEqual } from '@/utils/pageUtils'

export default {
  name: 'StepViewBusinessSurvey',
  props: {
    projectId: {
      type: String,
      default: null
    },
    industryId: {
      type: String,
      default: null
    },
    progressInStep: {
      type: Boolean,
      default: true
    }
  },
  components: {
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Card.name]: Card,
    [Tooltip.name]: Tooltip,
    functionTable,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [Tag.name]: Tag
  },
  computed: {},
  created() {
    this.$emit('openChangeDialog', { projectId: this.projectId })
    this.$emit('showBtns', {
      preStep: false,
      nextStep: false,
      saveStep: false,
      enableTabChange: true
    })
    this.getInitData()
    this.appear()
  },
  mounted() {},
  data() {
    return {
      currentColor: '#ccc',
      intervalId: null,
      flashCount: 0,
      showText: true,
      select: false,
      maxLength: 14,
      sceneDesc: null,
      caseDialogVisible: false,
      selectTrade: this.industryId,
      selectScene: [],
      addScene: false,
      selectSceneMap: {},
      oldSceneList: [],
      oldSceneFeatureMap: {},
      specIndustryList: [],
      specIndustryMap: {},
      specSceneList: [],
      specSceneMap: {},
      selectFunctionItem: null,
      specSceneGroup: {},
      specSceneItemGroup: [],
      specSceneItemGroup_index: {},
      selectSpecSceneList: [],
      caseDetail: {},
      tempData: {},
      changeVersion: false,
      productVersion: null,
      selectProductVersion: [],
      projectCompetitors: [],
      initSelectProductVersion: [],
      productVersionSelectFeature: [],
      hasChangScene: false,
      scene_index_name: '所有场景',
      isChannel: this.$store.getters.baseInfo.channel
    }
  },
  methods: {
    appear() {
      this.flashCount = 0
      clearInterval(this.intervalId)
      this.intervalId = setInterval(() => {
        this.currentColor = this.currentColor == 'red' ? '#ccc' : 'red'
        this.showText = !this.showText
        this.flashCount++
        if (this.flashCount >= 8) {
          clearInterval(this.intervalId)
          this.currentColor = 'red'
          this.showText = true
        }
      }, 400)
    },
    getStepInitData() {
      this.oldSceneList = []
      getSceneResearch({ projectId: this.projectId }).then(res => {
        var selectFeature = res.data.content.sceneFeature
        this.initProductVersion(res.data.content)
        for (let index = 0; index < selectFeature.length; index++) {
          const element = selectFeature[index]
          this.oldSceneList.push(element.sceneId)
          this.oldSceneFeatureMap[element.sceneId] = element.featureIdList
          if (this.specSceneMap[element.sceneId]) {
            var select = this.specSceneMap[element.sceneId]
            this.$set(this.specSceneMap[element.sceneId], 'select', true)

            select.selectFeatrueIds = element.featureIdList
            select.featureTotal = element.featureTotal ? element.featureTotal : 0
            select.selectFeatrueCont = element.featureIdList.length
            this.selectFunctionItem = this.specSceneMap[element.sceneId]
            select.requiredCont = 0
            select.selectRequiredCont = 0
            select.recommentCont = 0
            select.selectRecommentCont = 0
            select.optionalCont = 0
            select.selectOptionalCont = 0
            this.selectScene.push(select)
            select.hasFirst = false
            this.reloadSlectSceneList()
            // this.getSpecListData(select, element.sceneId, index)
          }
        }

        this.tempData = this.getTempData()
      })
    },
    initProductVersion(resContent) {
      var instProductDtoList = resContent.instProductDtoList
      this.productVersionSelectFeature = []
      this.selectProductVersion = []
      this.productVersion = []

      for (const instProductDto of instProductDtoList) {
        instProductDto.selectFeatureIds = []
        instProductDto.supportFeatureIds = []
        instProductDto.unSupportFeatureids = []
        instProductDto.selectFeatureIds = instProductDto.selectFeatureIdList

        this.productVersion.push(instProductDto)
        this.selectProductVersion.push(instProductDto.id)
        this.initSelectProductVersion.push(instProductDto.id)
        const combinedArray = [...new Set([...this.productVersionSelectFeature, ...instProductDto.selectFeatureIdList])]
        this.productVersionSelectFeature = combinedArray
      }
      this.reloadSceneFeatureInfo()
    },
    buildSelectProductVersion(handelVersion) {
      this.selectProductVersion = []
      this.hasChangScene = false
      this.productVersionSelectFeature = []
      this.productVersion = handelVersion
      for (const version of handelVersion) {
        const combinedArray = [...new Set([...this.productVersionSelectFeature, ...version.supportFeatureIds])]
        this.selectProductVersion.push(version.versionId)
        this.ol
        this.productVersionSelectFeature = combinedArray
      }

      var equal = isDeepEqual(this.initSelectProductVersion, this.selectProductVersion)
      if (!equal) {
        this.changeVersion = true
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      }

      this.reloadSceneFeatureInfo()
      this.reloadSlectSceneList()
    },
    handelSelectProductVersion() {
      var scene = this.selectScene.filter(item => item.sceneType !== 'COMMON_SCENE')
      if (scene.length === 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一个业务场景', type: 'error' })
        return
      }
      var sceneIdList = []
      for (const element of scene) {
        sceneIdList.push(element.id)
        if (element.relationSceneIdList) {
          for (const elScene of element.relationSceneIdList) {
            sceneIdList.push(elScene.id)
          }
        }
      }

      // const temp = JSON.parse(JSON.stringify(this.selectScene))
      // this.selectScene = []

      const uniqueArray = sceneIdList.filter((item, index) => sceneIdList.indexOf(item) === index)

      const _this = this
      var dialog = this.$dialog({
        template: h => {
          const projectId = this.projectId
          const projectCompetitors = this.projectCompetitors
          const selectProductInfo = this.productVersion
          return (
            <product-version-select
              sceneIdList={uniqueArray}
              projectId={projectId}
              projectCompetitors={projectCompetitors}
              selectProductInfo={selectProductInfo}
              onCb={function(cbParams) {
                if (cbParams.action === 'confirm') {
                  _this.buildSelectProductVersion(cbParams.data)
                }
                dialog.remove()
              }}
            ></product-version-select>
          )
        },
        components: {
          ProductVersionSelect
        },
        props: {
          title: '选择对应的版本信息',
          width: '85%',
          'custom-class': 'custom-change-detail-dialog-left',
          showCancelBtn: false, // 隐藏取消按钮
          showClose: false, // 隐藏关闭按钮
          showDefaultFooter: false, //隐藏确定和取消按钮
          closeOnPressEscape: false, // 不能通过ESC键关闭
          closeOnHashChange: false // 不能通过路由改变关闭
        }
      })
    },
    getSpecListData(item, sceneId, index) {
      const params = {
        matchArr: [
          {
            type: 'EXACT',
            fieldName: 'sceneId',
            valueArr: [item.id],
            matchRule: 'EQ'
          }
        ],
        page: this.page - 1,
        limit: 1000
      }

      if (this.selectProductVersion.length > 0) {
        params.matchArr.push({
          type: 'EXACT',
          fieldName: 'productId',
          valueArr: this.selectProductVersion,
          matchRule: 'EQ'
        })
      }

      listSpecFeature(params).then(res => {
        var specFeatureList = res.data.content.itemArr
        item.featureTotal = res.data.content.total
        item.allSpecFeature = specFeatureList
        this.changeSuummaryCont(item, sceneId, index)
      })
    },
    changeSuummaryCont(item, sceneId, index) {
      // 必选数量
      var selectFeatrueIds = item.selectFeatrueIds

      var REQUIREDList = item.allSpecFeature.filter(specItem => {
        return specItem.featureType === 'REQUIRED'
      })
      // 已选的必选数量
      item.requiredCont = REQUIREDList.length
      this.$set(item, 'requiredCont', REQUIREDList.length)
      var selectREQUIREDList = item.allSpecFeature.filter(specItem => {
        return specItem.featureType === 'REQUIRED' && selectFeatrueIds.includes(specItem.id)
      })
      // 推荐数量
      item.selectRequiredCont = selectREQUIREDList.length
      this.$set(item, 'selectRequiredCont', selectREQUIREDList.length)
      var RECOMMENDList = item.allSpecFeature.filter(specItem => {
        return specItem.featureType === 'RECOMMEND'
      })
      // 已选推荐数量
      item.recommentCont = RECOMMENDList.length
      this.$set(item, 'recommentCont', RECOMMENDList.length)
      if (item.hasFirst) {
        var selectRECOMMENDListALL = item.allSpecFeature.filter(specItem => {
          return specItem.featureType === 'RECOMMEND'
        })
        var ids = selectRECOMMENDListALL.map(item => {
          return item.id
        })
        item.selectFeatrueIds = ids
        item.selectFeatrueCont = ids.length

        item.selectRecommentCont = selectRECOMMENDListALL.length
        this.$set(item, 'selectRecommentCont', selectRECOMMENDListALL.length)
        item.hasFirst = false
      } else {
        var selectRECOMMENDList = item.allSpecFeature.filter(specItem => {
          return specItem.featureType === 'RECOMMEND' && selectFeatrueIds.includes(specItem.id)
        })

        item.selectRecommentCont = selectRECOMMENDList.length
        this.$set(item, 'selectRecommentCont', selectRECOMMENDList.length)
      }

      var OPTIONALList = item.allSpecFeature.filter(specItem => {
        return specItem.featureType === 'OPTIONAL'
      })
      // 可选的数量
      item.optionalCont = OPTIONALList.length
      this.$set(item, 'optionalCont', OPTIONALList.length)
      var selectOPTIONALList = item.allSpecFeature.filter(specItem => {
        return specItem.featureType === 'OPTIONAL' && selectFeatrueIds.includes(specItem.id)
      })
      item.selectOptionalCont = selectOPTIONALList.length
      this.$set(item, 'selectOptionalCont', selectOPTIONALList.length)

      this.updateAttrData(item, sceneId)
    },
    updateAttrData(item, sceneId) {
      for (let index = 0; index < this.selectScene.length; index++) {
        const element = this.selectScene[index]
        if (sceneId === element.id) {
          this.selectScene.splice(index, 1, item)
          this.$forceUpdate()
        }
      }
    },
    getInitData() {
      getIndustryScene({}).then(res => {
        this.specIndustryList = res.data.content.specIndustry
        this.specIndustryList.forEach(element => {
          this.specIndustryMap[element.id] = element
        })

        if (this.specIndustryMap[this.industryId]) {
          this.sceneDesc = this.specIndustryMap[this.industryId].sceneDesc
        }

        this.specSceneList = res.data.content.specScene

        this.specSceneList.forEach(element => {
          element.select = false
          element.totalFeatrueCont = 0
          element.selectFeatrueCont = 0
          this.specSceneMap[element.id] = element
        })

        this.specSceneGroup = this.specSceneList.reduce((accumulator, current) => {
          const key = current.industryId
          if (!accumulator[key]) {
            accumulator[key] = []
          }
          accumulator[key].push(current)
          return accumulator
        }, {})
        this.changeSpecIndustry()
        this.getStepInitData()
        this.getProjectCompetitor()
      })
    },
    getProjectCompetitor() {
      if (this.projectId) {
        getProjectCompetitor({ id: this.projectId }).then(res => {
          this.projectCompetitors = res.data.content
        })
      }
    },
    queryEnd(params) {
      for (let index = 0; index < this.selectScene.length; index++) {
        if (this.selectScene[index].id === params.sceneId) {
          this.selectScene[index].featureTotal = 0
          this.$set(this.selectScene[index], 'featureTotal', params.total)
          this.selectScene[index].requiredCont = 0
          this.$set(this.selectScene[index], 'requiredCont', params.requiredCont)
          this.selectScene[index].selectRequiredCont = 0
          this.$set(this.selectScene[index], 'selectRequiredCont', params.selectRequiredCont)
          this.selectScene[index].recommentCont = 0
          this.$set(this.selectScene[index], 'recommentCont', params.recommentCont)
          this.selectScene[index].selectRecommentCont = 0
          this.$set(this.selectScene[index], 'selectRecommentCont', params.selectRecommentCont)
          this.selectScene[index].optionalCont = 0
          this.$set(this.selectScene[index], 'optionalCont', params.optionalCont)
          this.selectScene[index].selectOptionalCont = 0
          this.$set(this.selectScene[index], 'selectOptionalCont', params.selectOptionalCont)
          this.selectScene[index].selectFeatrueCont = 0

          this.$set(this.selectScene[index], 'selectFeatrueCont', params.selectFeatrueCont)
          this.updateAttrData(this.selectScene[index], params.sceneId)
        }
      }
    },
    changeSpecIndustry() {
      if (this.selectTrade in this.specSceneGroup) {
        var specSceneItem = this.specSceneGroup[this.selectTrade]
        this.specSceneItemGroup = specSceneItem.reduce((acc, cur) => {
          const key = cur.sceneTypeName
          if (!acc[key]) {
            acc[key] = []
          }

          acc[key].push(cur)
          return acc
        }, {})

        this.specSceneItemGroup_index = specSceneItem.reduce((acc, cur) => {
          const sceneDirName = cur.sceneDirName
          const key = cur.sceneTypeName
          if (!acc[key]) {
            acc[key] = ['所有场景']
          }
          if (sceneDirName) {
            if (!acc[key].includes(sceneDirName)) {
              acc[key].push(sceneDirName)
            }
          }

          return acc
        }, {})
      } else {
        this.specSceneItemGroup = {}
        this.specSceneItemGroup_index = []
      }
    },
    reloadSelectScene(index, key, item) {},
    reloadSlectSceneList() {
      for (let index = 0; index < this.selectScene.length; index++) {
        const sceneItem = this.selectScene[index]

        this.getSpecListData(sceneItem, sceneItem.id, index)
        this.selectSceneFunction(sceneItem)
      }
    },
    changeTrade(selectItem) {
      this.selectTrade = selectItem
      this.changeSpecIndustry()
    },
    selectSpecScene(select, row, index, key) {
      this.appear()
      if (this.selectProductVersion.length !== 0 && key !== '通用场景') {
        var showTips = false
        if (!this.addScene) {
          showTips = true
        }

        if (showTips) {
          this.$confirm(
            '此操作将会清空之前的版本选择，同时后续流程需要重新走，确定变更场景并重新选择对应的版本吗？（本操作不可回退）',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.selectProductVersion = []
              this.changeSpecScene(select, row, index, key)
            })
            .catch(() => {
              // this.changeSpecScene(this.specSceneMap[row.id].select, row, index, key)
            })
        } else {
          this.changeSpecScene(select, row, index, key)
        }
      } else {
        this.changeSpecScene(select, row, index, key)
      }
    },
    changeSpecScene(select, row, index, key) {
      this.$set(this.specSceneMap[row.id], 'select', select)
      this.$set(this.specSceneItemGroup[key], index, this.specSceneMap[row.id])

      if (select) {
        if (!row.selectFeatrueIds) {
          row.selectFeatrueIds = []
        }
        if (row.selectFeatrueIds && row.selectFeatrueIds.length == 0) {
          row.selectFeatrueIds = []
        }

        this.selectScene.push(row)
        if (row.relationSceneIdList && row.relationSceneIdList.length > 0) {
          for (const relItem of row.relationSceneIdList) {
            var relaObj = this.specSceneMap[relItem.id]
            const exists = this.selectScene.some(obj => obj.id === relaObj.id)
            if (exists) {
              continue
            }
            if (!relaObj.selectFeatrueIds) {
              relaObj.selectFeatrueIds = []
            }
            if (relaObj.selectFeatrueIds && relaObj.selectFeatrueIds.length == 0) {
              relaObj.selectFeatrueIds = []
            }
            this.$set(this.specSceneMap[relaObj.id], 'select', select)
            this.selectScene.push(relaObj)
            relaObj.hasFirst = true
            this.getSpecListData(relaObj, relaObj.id)
          }
        }
        this.selectFunctionItem = Object.assign({}, this.selectFunctionItem, row)
        row.hasFirst = false
        this.getSpecListData(row, row.id)
      } else {
        for (let index = 0; index < this.selectScene.length; index++) {
          if (this.selectScene[index].id === row.id) {
            this.selectScene.splice(index, 1)
            if (this.selectFunctionItem.id === row.id) {
              if (this.selectScene.length > 0) {
                this.selectFunctionItem = Object.assign(
                  {},
                  this.selectFunctionItem,
                  this.selectScene[this.selectScene.length - 1]
                )
              } else {
                this.selectFunctionItem = null
              }
            }
          }
        }
      }
      this.addScene = false

      for (const iterator of this.selectScene) {
        const exists = this.oldSceneList.some(obj => iterator.id === obj)
        if (!exists) {
          this.addScene = true

          if (key !== '通用场景') {
            this.hasChangScene = true
          }
          break
        }
      }
      if (this.selectScene.length !== this.oldSceneList.length && !this.addScene && !this.changeVersion) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: true,
          enableTabChange: false
        })
      } else {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      }
    },
    reloadSceneFeatureInfo() {
      this.$nextTick(() => {
        for (const element of this.selectScene) {
          if (this.$refs[element.id]) {
            this.$refs[element.id][0].reloadData()
          }
        }
      })
    },
    showSceneCasePage(data) {
      getSceneDetail(data).then(res => {
        this.caseDialogVisible = true
        this.caseDetail = res.data.content
      })
    },
    functionChangeSelect(params) {
      for (let index = 0; index < this.selectScene.length; index++) {
        const element = this.selectScene[index]
        if (params.sceneId === element.id) {
          var aa = this.selectScene[index]
          aa.selectFeatrueIds = params.selectIds
          aa.selectFeatrueCont = params.selectIds.length
          this.changeSuummaryCont(aa, params.sceneId)
          this.$set(this.selectScene, index, aa)
        }
      }
      var oldIds = this.oldSceneFeatureMap[params.sceneId]
      var newIds = params.selectIds
      var uniqueElements = newIds.filter(element => !oldIds.includes(element))
      if (this.addScene || this.changeVersion) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      } else {
        if (
          uniqueElements.length > 0 ||
          oldIds.length !== newIds.length ||
          this.selectScene.length !== this.oldSceneList.length
        ) {
          this.$emit('showBtns', {
            preStep: false,
            nextStep: false,
            saveStep: true,
            enableTabChange: true
          })
        } else {
          this.$emit('showBtns', {
            preStep: false,
            nextStep: false,
            saveStep: false,
            enableTabChange: true
          })
        }
      }

      this.specSceneMap[params.sceneId].selectIds = params.ids
    },
    selectSceneFunction(item, index) {
      this.appear()
      this.selectFunctionItem = Object.assign({}, this.selectFunctionItem, item)
      this.$nextTick(() => {
        const functionTableRef = this.$refs[item.id]?.[0] // 获取对应场景的 functionTable 实例
        if (functionTableRef) {
          functionTableRef.reloadData() // 调用子组件重置方法
        }
      })
    },
    reloadSelectSceneFunction() {
      for (const element of this.selectScene) {
        this.selectSceneFunction(element)
      }
    },
    handleCloseDrawer() {
      this.caseDialogVisible = false
    },
    async saveStep() {
      var save_req = {
        projectId: this.projectId,
        industryId: this.selectTrade,
        flowStep: 'MDR_SCENE_RESEARCH',
        sceneFeature: [],
        productIdList: this.selectProductVersion
      }

      var hasComm = false
      for (const iterator of this.selectScene) {
        var featureItem = {
          sceneId: iterator.id,
          featureIdList: iterator.selectFeatrueIds
        }
        if (iterator.sceneType === 'BUSI_SCENE') {
          hasComm = true
        }
        save_req.sceneFeature.push(featureItem)
      }

      if (!hasComm) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一个业务场景', type: 'error' })
        return false
      }

      if (this.selectProductVersion.length == 0) {
        this.$store.dispatch('OpenNotification', { message: '选择产品及对应版本', type: 'error' })
        return false
      }

      var result = false
      await saveSceneResearch(save_req)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            result = true
          }
        })
        .catch(e => {
          result = false
        })
      this.tempData = this.getTempData()
      if (this.addScene || this.changeVersion) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      } else {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: true,
          enableTabChange: true
        })
      }

      return result
    },
    getTempData() {
      var save_req = {
        projectId: this.projectId,
        industryId: this.selectTrade,
        flowStep: 'MDR_SCENE_RESEARCH',
        sceneFeature: [],
        productIdList: this.selectProductVersion
      }

      for (const iterator of this.selectScene) {
        var featureItem = {
          sceneId: iterator.id,
          featureIdList: iterator.selectFeatrueIds
        }
        save_req.sceneFeature.push(featureItem)
      }
      return save_req
    },
    getData() {
      var save_req = this.getTempData()

      var equal = isDeepEqual(this.tempData, save_req)

      if (equal) {
        return {
          dataChange: false
        }
      } else {
        this.tempData = save_req
        return {
          dataChange: true,
          busDATA: save_req
        }
      }
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      var save_req = {
        projectId: this.projectId,
        industryId: this.selectTrade,
        flowStep: 'MDR_SCENE_RESEARCH',
        sceneFeature: [],
        productIdList: this.selectProductVersion
      }

      var hasComm = false
      for (const iterator of this.selectScene) {
        var featureItem = {
          sceneId: iterator.id,
          featureIdList: iterator.selectFeatrueIds
        }
        if (iterator.sceneType === 'BUSI_SCENE') {
          hasComm = true
        }
        save_req.sceneFeature.push(featureItem)
      }

      if (!hasComm) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一个业务场景', type: 'error' })
        return false
      }
      if (this.selectProductVersion.length == 0) {
        this.$store.dispatch('OpenNotification', { message: '选择产品及对应版本', type: 'error' })
        return false
      }
      var result = true
      await saveSceneResearch(save_req)
        .then(res => {})
        .catch(e => {
          result = false
        })
      this.$emit('showBtns', {
        preStep: false,
        nextStep: false,
        saveStep: false,
        enableTabChange: false
      })
      return result
    },
    gotoPreStep() {},
    isShowTooltip(content) {
      return content.length > this.maxLength
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(business-survey) {
  position: relative;
  height: 100%;
  overflow-y: scroll;
  .business-survey-group-buttom {
    height: 128px;
  }

  .wsp-link .el-checkbox__label {
    color: #38a4f5 !important;
    cursor: pointer;
  }
  .business-survey-group {
    .business-survey-group-title {
      display: flex;
      margin: 3px 0;
      .business-survey-group-title-icon {
        width: 6px;
        line-height: 28px;
        background-color: #0052d9;
      }
      .business-survey-group-title-value {
        font-size: 18px;
        line-height: 28px;
        padding-left: 12px;
      }
      .business-survey-group-title-tip {
        line-height: 28px;
        padding-left: 12px;
        color: #38a4f5;
      }
    }

    .business-survey-group-content {
      .business-info-item {
        display: flex;
        line-height: 28px;
        .business-info-item-title {
          width: 120px;
          text-align: right;
          font-weight: 600;
          padding-right: 6px;
        }
      }
      ::-webkit-scrollbar {
        width: 3px;
      }
      ::-webkit-scrollbar-track {
        border-radius: 3px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #cccccc;
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #999999;
      }
      .scene-group {
        display: block;
        .scene-group-item {
          display: flex;
          .scene-group-item-title {
            width: 8%;
            text-align: right;
            font-weight: 600;
            padding-right: 6px;
          }
          .scene-group-item-content {
            width: 88%;
            .scene-group-header {
              margin-bottom: 6px;
              cursor: pointer;
              .scene-group-header-item {
                padding: 0 12px;
                text-align: center;
                border-radius: 18px;
                border: 1px solid #d9d7d7;
                line-height: 24px;
              }
              .scene-group-header-item-border {
                border: 1px solid #d9d7d7;
                background-color: #38a4f5;
                color: #fff;
              }
              .scene-group-header-item:hover {
                border: 1px solid #38a4f5;
                background-color: #38a4f5;
                color: #fff;
              }
            }
            .scene-group-item-custom-value {
              height: 96px;
              overflow-y: auto;
            }
            .scene-group-item-value {
              display: flex;
              flex-wrap: wrap;
              .scene-item-hidder {
                display: none;
              }
              .scene-item-checkbox {
                width: 30%;
                margin-left: 0px !important;
                .el-checkbox {
                  width: 100%;
                }
                .el-checkbox__label {
                  overflow: hidden !important;
                  white-space: nowrap !important;
                  text-overflow: ellipsis !important;
                  vertical-align: middle !important;
                  width: 90% !important;
                }
              }
            }
          }
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .content-scene-detail {
    .scene-item-function {
      padding-bottom: 18px;
      height: 600px;
    }
    .scene-item-function-empty {
      height: 10vh;
    }
    .scene-simple-card {
      display: flex;
      padding: 3px;
      margin-bottom: 12px;
      cursor: pointer;
      flex-wrap: wrap;
      .active {
        background: rgba(0, 82, 217, 0.0389);
        border-color: #0052d9;
        border: 1px solid #0052d9;
      }

      .scene-item-content {
        .scene-attr-item {
          width: 100%;
          text-align: center;
          line-height: 28px;
        }
      }
      .scene-item {
        line-height: 28px;
        width: 19%;
        margin: 6px;
        .scene-item-title {
          width: 70%;
          padding: 12px 6px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .el-card__header {
          padding: 0 !important;
        }
        .el-card__body {
          padding: 0 !important;
        }
      }
    }
    scene-detail-card {
      height: 580px;
      overflow-y: scroll;
    }
    .scene-item {
      .scene-item-title {
        float: left;
        display: flex;
        line-height: 24px;
        .scene-item-title-value {
          font-weight: bolder;
          border-bottom: none;
          padding: 3px 24px;
          text-align: center;
          border-radius: 6px 6px 0 0;
          background-color: #63c1ff;
        }
        .scene-item-title-btn {
          padding: 3px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: $--color-primary;
          cursor: pointer;
        }
      }
    }
  }
  .content-scene-drawer-detail {
    height: 100%;
    overflow-y: auto;
    .scene-case-detail-content {
      padding: 12px 24px;
      .scene-case-detail-item {
        display: flex;
        line-height: 28px;
        .item-label {
          text-align: right;
          font-weight: 600;
          width: 15%;
        }
        .item-value {
          width: 85%;
          word-break: break-all;
          white-space: pre-wrap;
          .item-tag {
            margin: 0 3px;
          }
        }
      }
    }
  }
}
</style>
